import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboCachingPotentialDatabasesResponse } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.listCachingPotentialDatabases;

const DBO_CACHING_POTENTIAL_DATABASES_QUERY_KEY =
  'dbo-caching-potential-databases';

const getCachingPotentialDatabasesQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => {
  return [DBO_CACHING_POTENTIAL_DATABASES_QUERY_KEY, params] as const;
};

export const useCachingPotentialDatabasesQuery = <
  TSelected = DboCachingPotentialDatabasesResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DboCachingPotentialDatabasesResponse, TSelected>
) =>
  useQuery(
    queryOptions({
      queryKey: getCachingPotentialDatabasesQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      placeholderData: keepPreviousData,
      ...options,
    })
  );
